import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Checkbox } from './checkbox/checkbox';
import { FormsModule } from '@angular/forms';
import { CheckboxModule as PCheckboxModule } from 'primeng/checkbox';


@NgModule({
  declarations: [
    Checkbox
  ],
  imports: [
    CommonModule,
    FormsModule,
    PCheckboxModule,
  ],
  exports: [
    Checkbox,
  ]
})
export class CheckboxModule { }
